export default class Modal {
	static init() {
		Array.from(document.querySelectorAll('.modal')).forEach(element => {
			new Modal(element);
		});
	}

	classes = {
		node: 'modal',
		get visible() {return this.node + '--is-visible'},
		get link() {return this.node + '-link'},
		get closeBtn() {return this.node + '__close-btn'},
		get backdrop() {return this.node + '__backdrop'},
	}
	isVisible = false;

	constructor(element) {
		this.element = element;
		this.modalNode = element;

		let linkNodesArray = Array.from(document.querySelectorAll('.' + this.classes.link));

		let closeBtnNode = element.querySelector('.' + this.classes.closeBtn);
		let backdropNode = element.querySelector('.' + this.classes.backdrop);

		if (closeBtnNode) {
			closeBtnNode.addEventListener('click', () => {
				this.hide(this.modalNode)
			});
		}
		if (backdropNode) {
			backdropNode.addEventListener('click', () => {
				this.hide(this.modalNode)
			});
		}

		linkNodesArray.forEach(el => {
			el.addEventListener('click', e => {
				e.preventDefault();
				e.stopPropagation();

				this.modalNode = document.querySelector('#' + el.href.split('#')[1]);
				this[this.isVisible ? 'hide' : 'show'](this.modalNode);
			});
		});
	}

	show(element) {
		element.classList.add(this.classes.visible)
		this.isVisible = true;
	}

	hide(element) {
		this.isVisible = false;
		element.classList.remove(this.classes.visible)
	}
}
